import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=91618b86"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.5.0_webpack@5.105.4_clean-css@5.3.3_cssnano@5.0.0_postc_348cc87412143943e30698abc63cb6b0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports